import React, { useEffect, useState } from "react";
import axios from "axios";
import Loader from "../components/Loader";
import LegalNoticeCard from "../components/LegalNoticeCard";
import Title from "../components/Title";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "../slice/tokenSlice";
import { FaFilter, FaLink, FaRupeeSign, FaTimes } from "react-icons/fa";

const LegalNotice = () => {
  const dispatch = useDispatch();
  const { url, user } = useSelector((state) => state.user);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [loading, setLoading] = useState(false);
  const getLegalNotice = async () => {
    try {
      const token = await dispatch(getToken());
      setLoading(true);
      const res = await axios.get(
        `${url}/proxy?url=https://www.zohoapis.in/crm/v2/Leads/${user.id}/Add_On_Charges`,
        {
          headers: {
            Authorization: `Zoho-oauthtoken ${token.payload}`,
          },
        }
      );
      if (res.status === 200) {
        const data = res.data.data;
        data.forEach((item) => {
          Object.keys(item).forEach((key) => {
            item[key] = item[key] ?? "";
            if (key === "Payment_Status") {
              if (item[key] === "") {
                item.pillStatus = "";
              } else if (item[key].toLowerCase() === "paid") {
                item.pillStatus = "paid-pill";
              } else if (item[key].toLowerCase() === "pending") {
                item.pillStatus = "pending-pill";
              }
            }
          });
        });
        //
        setData1(data);
        setData2(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (user !== null) {
      getLegalNotice();
    }
  }, [user]);
  //
  const [searchInput, setSearchInput] = useState("");
  const filterData = () => {
    console.log(searchInput);
    const filtered = data1.filter((item) => {
      const name = item?.Name?.toLowerCase().includes(
        searchInput.toLowerCase()
      );

      const statusMatch =
        filterInputs.status === "" ||
        item?.Status?.toLowerCase() === filterInputs.status.toLowerCase();

      const billDateMatch =
        filterInputs.billDate === "" ||
        item?.Bill_Date?.toLowerCase() === filterInputs.billDate.toLowerCase();

      return name && statusMatch && billDateMatch;
    });
    setData2(filtered);
    setModalVisible(false);
  };
  const resetSearchFilter = () => {
    setSearchInput("");
    setFilterInputs({
      creditType: "",
      status: "",
      billDate: "",
      paidDate: "",
    });
    setModalVisible(false);
    setData2(data1);
  };
  useEffect(() => {
    filterData();
  }, [searchInput, data1]);
  //
  const [filterInputs, setFilterInputs] = useState({
    creditType: "",
    status: "",
    billDate: "",
    paidDate: "",
  });
  const handleFilterInputs = (e) => {
    const { name, value } = e.target;
    setFilterInputs({
      ...filterInputs,
      [name]: value,
    });
  };
  const [modalVisible, setModalVisible] = useState(false);
  const openModal = () => {
    setModalVisible(true);
  };
  const closeModal = () => {
    setModalVisible(false);
  };
  return (
    <>
      <div className="payments-container">
        <div className="d-flex justify-content-between gap-2 flex-sm-row flex-column">
          <Title title="Legal Charges" />
          <div className="filter-flex">
            <input
              type="text"
              className="input"
              placeholder="Search..."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <button className="button" onClick={openModal}>
              <FaFilter />
            </button>
          </div>
        </div>
        <hr />
        <div className="project-table-overflow">
          {loading === true ? (
            <Loader />
          ) : (
            <>
              {data2.length === 0 ? (
                <p className="text-center">No data found</p>
              ) : (
                <table className="project-table legal-notice-table">
                  <thead>
                    <tr>
                      <th>Sr</th>
                      <th>Name</th>
                      <th>Amount</th>
                      <th>Notice Type</th>
                      <th>Creditor Name</th>
                      <th>Invoice Date</th>
                      <th>Add On Status</th>
                      <th>Payment Status</th>
                      <th>Payment Date</th>
                      <th>Invoice Number</th>
                      <th>Payment Link</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data2.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.Name || "-"}</td>
                          <td>{item.Amount || "-"}</td>
                          <td>{item.Type || "-"}</td>
                          <td>{item.Creditor_Name?.name || "-"}</td>
                          <td>
                            {item.Date?.split("-").reverse().join("-") || ""}
                          </td>
                          <td> {item.Status || ""}</td>
                          <td>
                            {" "}
                            <span className={`pill ${item.pillStatus}`}>
                              {item.Payment_Status || ""}
                            </span>
                          </td>
                          <td>
                            {" "}
                            {item.Payment_Date?.split("-")
                              .reverse()
                              .join("-") || ""}
                          </td>
                          <td> {item.Invoice_Number || ""}</td>
                          <td>
                            <a
                              href={item.Payment_Link}
                              target="_blank"
                              className={`button d-block mt-2 ${
                                item.Payment_Link === ""
                                  ? "disabled-button"
                                  : ""
                              }`}
                            >
                              <FaLink />
                            </a>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </>
          )}
        </div>
      </div>
      <div
        className={`modal-background ${modalVisible ? "active" : ""}`}
        style={{ zIndex: "100" }}
      >
        <div className="modal-container">
          <div className="d-flex align-items-end justify-content-between">
            <h2>Filter</h2>
            <button className="red-button" onClick={closeModal}>
              <FaTimes />
            </button>
          </div>
          {/*  */}
          <hr />
          <div>
            <div className="mt-4">
              <p className="mb-2">Status</p>
              <select
                className="input"
                name="status"
                value={filterInputs.status}
                onChange={handleFilterInputs}
              >
                <option value="">Select</option>
                <option value="Paid">Paid</option>
                <option value="Pending">Pending</option>
                <option value="Sent">Sent</option>
                <option value="Partially Paid">Partially Paid</option>
                <option value="Draft">Draft</option>
                <option value="Void">Void</option>
              </select>
            </div>
            <div className="mt-4">
              <p className="mb-2">Payment date</p>
              <input
                type="date"
                className="input"
                name="billDate"
                value={filterInputs.billDate}
                onChange={handleFilterInputs}
              />
            </div>
            <div className="mt-4">
              <p className="mb-2">Due date</p>
              <input
                type="date"
                className="input"
                name="paidDate"
                value={filterInputs.paidDate}
                onChange={handleFilterInputs}
              />
            </div>
          </div>
          <div className="d-flex align-content-center justify-content-end gap-2 mt-4">
            <button
              className="red-button"
              onClick={resetSearchFilter}
              style={{ width: "90px" }}
            >
              Reset
            </button>
            <button
              className="button"
              onClick={filterData}
              style={{ width: "90px" }}
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LegalNotice;
